import { datadogRum } from '@datadog/browser-rum';

export default async () => {
    datadogRum.init({
        applicationId: '3e4f24f1-ef02-457a-9184-8b7a126b810a',
        clientToken: 'pub0a14105f0f4e84f33a8c5a8c79316b7f',
        site: 'datadoghq.com',
        service: 'vue-widgets',
        env: DEPLOY_ENV,
        silentMultipleInit: true,
        defaultPrivacyLevel: 'mask-user-input',
        sessionSampleRate: 100,
        // May want to adjust this
        sessionReplaySampleRate: 1,
    });

    datadogRum.startSessionReplayRecording();
};
